import React, { useContext, useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import { useNavigate } from "react-router";
import { CreativeContext } from "./CreativeCreation";
import { SlProgressBar } from '@shoelace-style/shoelace/dist/react';
import { classifiedSectionCategories } from "../../utils/constants";
import { SlDrawer } from '@shoelace-style/shoelace/dist/react';

function RectangleClassified({
    company,
    companyName,
    handleshow,
    // advId,
    creative_name,
    creative_type,
    subtype,
    editdata,
    flag,
    handlesubmit,
    createdEdited
  }) {
    const navigate = useNavigate();
  const iconOptions = [
  { label: "None", value: "0" },
  { label: "Phone", value: "1" },
  { label: "Whatsapp", value: "2" },
  { label: "Form", value: "4" },
  { label: "Mail", value: "5" },
];
    const { preview, setPreview } = useContext(CreativeContext);
    const [progress, setProgress] = useState(0);
  
    const [imgurl, setImgurl] = useState("");
    const [initiator, setInitiator] = useState("")
    const [logoUrl, setLogoUrl] =  useState("")
  
    const [image, setImage] = useState("");


    const [showImageModal, setShowImageModal] = useState(false);
    const [imageName, setImageName] = useState("");
    const [imageFile, setImageFile] = useState(null);
    const [imageurls,setimageurls] = useState([]);
    
    const [newimageurl,setnewimageurl]=useState("");
    const fileInputRef = useRef(null);
    const resetDrawer = () => {
      setImageName(""); 
      setImageFile(null); 
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; 
      }
    };
    const imageChange = async (e, initiator='image') => {
      setValue("category","");
      setimageurls([])
      setInitiator(initiator)
      if (e.target.files && e.target.files.length > 0) {
        if (e.target.files[0].type === "image/jpg" || e.target.files[0].type === "image/jpeg" || e.target.files[0].type === "image/webp" || e.target.files[0].type === "image/png") {
          setImage(e.target.files[0]);
        } else {
          Toast("error", "Only jpg, jpeg, webp, png formats accepted")
          setValue("image", "")
        }
      } else {
        if (flag === "edit") {
          if(initiator === "image"){
            setImgurl("")
            setImgurl(editdata.img_urls);
            setPreview({ ...preview, img_urls: editdata.img_urls });
          }
          else{
            setLogoUrl("")
            setPreview(prev => ({ ...prev, logo_urls: editdata.gallery?.image }));
            setLogoUrl(editdata.gallery?.image)
          }
        } else {
          setProgress(0);
          if(initiator === "image"){
            setImgurl("");
            setPreview({ ...preview, img_urls: ""});
          }
          else{
            setPreview({ ...preview, logo_urls: "" });
            setLogoUrl("")
          }
        }
      }
    };
    const newimageChange = async(e)=>{
      const file = e.target.files[0];
      if (e.target.files && e.target.files.length > 0) {
        if (e.target.files[0].type === "image/jpg" || e.target.files[0].type === "image/jpeg" || e.target.files[0].type === "image/webp" || e.target.files[0].type === "image/png") {
          setImageFile(e.target.files[0]);
        } else {
          Toast("error", "Only jpg, jpeg, webp, png formats accepted")
          setImageFile(null);
          if(fileInputRef.current)
          {
            fileInputRef.current.value = "";
          }
          return;
        }
      }
      let newformData = new FormData();
      newformData.append("files", file);
      try{
        let res = await api({
          url: `/upload/brandImage`,
          method: "POST",
          responseType: "json",
          data: newformData,
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: data => {
            setProgress(Math.round((100 * data.loaded) / data.total))
          },
        });
        if(res.code == 200)
        {
          setnewimageurl(res.data?.data);
        }
    }
    catch(error)
    {
      console.log(error);
    }
  }

  
    const {
      register,
      handleSubmit,
      setValue,
      watch,
      formState: { errors },
    } = useForm({ mode: "onSubmit" });
    const formData = new FormData();
    formData.append("files", image);
    const imageUrl = async () => {
      try {
        let url = await api({
          url: `/upload/brandImage`,
          method: "POST",
          responseType: "json",
          data: formData,
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: data => {
            setProgress(Math.round((100 * data.loaded) / data.total))
          },
        });
        if (url.code === 200) {
          if(initiator === "image"){
            setImgurl(url.data?.data);
            setPreview(prev => ({ ...prev, img_urls: url.data?.data, sub_type:"rectangle_classified" }));
          }
          else{
            setPreview(prev => ({ ...prev, logo_urls: url.data?.data, sub_type:"rectangle_classified"}));
            setLogoUrl(url.data?.data)
          }
        } else {
          setProgress(0);
          setValue(initiator, null);
          if (flag === "edit") setImage("");
          Toast("error", url.data.message);
        }
      } catch (error) {
        Toast("error", error);
      }
    };
    useEffect(() => {
      if (image) {
        imageUrl();
      }
    }, [image]);

    useEffect(()=>{
      setPreview(prev => ({ ...prev, img_urls: imgurl }));
    },[imgurl])
    
    let watchcheck = watch("btnclick");
    if (flag === "edit")
      watchcheck = watch(
        "btnclick",
        editdata.button_enabled === 1 ? true : false
      );
    let watchdescription = watch('description')
      useEffect(() => {
        if (watchdescription !== "") {
          setPreview(prev => ({ ...prev, description: watchdescription }));
        } else {
          setPreview(prev => ({ ...prev, description: "" }));
        }
      }, [watchdescription]);
      let watchheadline = watch('headline')
      useEffect(() => {
        if (watchheadline !== "") {
          setPreview(prev => ({ ...prev, headline: watchheadline }));
        } else {
          setPreview(prev => ({ ...prev, headline: "" }));
        }
      }, [watchheadline]);
     
      let watchbackground = watch('background')
      useEffect(() => {
        if (watchbackground !== "") {
          setPreview(prev => ({ ...prev, background: watchbackground }));
        } else {
          setPreview(prev => ({ ...prev, background: "" }));
        }
      }, [watchbackground]);
    useEffect(() => {
      if (watchcheck !== false) {
        setPreview(prev => ({ ...prev, button_enabled: watchcheck, position: "Bottom" }));
      } else {
        setPreview(prev => ({ ...prev, button_enabled: false, position: "" }));
      }
    }, [watchcheck]);
  
    let watchbtntext = watch("btntext");
    useEffect(() => {
  
      if (watchbtntext !== "") {
        setPreview(prev => ({ ...prev,button_enabled : watchcheck,button_link: watchbtnurl, button_text: watchbtntext, btn_text_lang: watchbuttonLang, btn_text_clr: watchbtntextclr, btn_text_bgclr: watchbtntextbgclr }));
      } else {
        setPreview(prev => ({ ...prev,button_enabled : watchcheck,button_link: watchbtnurl, button_text: "", btn_text_lang: watchbuttonLang, btn_text_clr: watchbtntextclr, btn_text_bgclr: watchbtntextbgclr }));
      }
    }, [watchbtntext]);
  
    let watchbtnurl = watch("btnurl", false);
    useEffect(() => {
      if (watchbtnurl) {
        const isMobileNumber = /^[6-9]\d{9}$/.test(watchbtnurl);
        // Check if it's a WhatsApp link
        const isWhatsappLink = /^https:\/\/wa.me\/\d+/.test(watchbtnurl);
        if (isMobileNumber) {
          setValue("btn_type", "1"); 
        } else if (isWhatsappLink) {
          setValue("btn_type", "2"); 
        }
      }
      if (watchbtnurl !== "") {
        setPreview(prev => ({ ...prev,button_enabled : watchcheck,button_link: watchbtnurl, button_text: watchbtntext, btn_text_lang: watchbuttonLang, btn_text_clr: watchbtntextclr, btn_text_bgclr: watchbtntextbgclr }));
      } else {
        setPreview(prev => ({ ...prev,button_enabled : watchcheck,button_link: '', button_text: watchbtntext, btn_text_lang: watchbuttonLang, btn_text_clr: watchbtntextclr, btn_text_bgclr: watchbtntextbgclr}));
      }
    }, [watchbtnurl]);
  
    let watchbuttonLang = watch("buttonLang", false);
    useEffect(() => {
  
      if (watchbuttonLang !== "") {
        setPreview(prev => ({ ...prev, button_enabled : watchcheck,button_link: watchbtnurl, button_text: watchbtntext, btn_text_lang: watchbuttonLang, btn_text_clr: watchbtntextclr, btn_text_bgclr: watchbtntextbgclr }));
      } else {
        setPreview(prev => ({ ...prev,button_enabled : watchcheck,button_link: watchbtnurl, button_text: watchbtntext, btn_text_lang: '', btn_text_clr: watchbtntextclr, btn_text_bgclr: watchbtntextbgclr }));
      }
    }, [watchbuttonLang]);
  
    let watchbtntextclr = watch("btntextclr")
    useEffect(() => {
  
      if (watchbtntextclr !== "") {
        setPreview(prev => ({ ...prev,button_enabled : watchcheck,button_link: watchbtnurl, button_text: watchbtntext, btn_text_lang: watchbuttonLang, btn_text_clr: watchbtntextclr, btn_text_bgclr: watchbtntextbgclr }));
      } else {
        setPreview(prev => ({ ...prev,button_enabled : watchcheck,button_link: watchbtnurl, button_text: watchbtntext, btn_text_lang: watchbuttonLang, btn_text_clr: '', btn_text_bgclr: watchbtntextbgclr}));
      }
    }, [watchbtntextclr]);
  
    let watchbtntextbgclr = watch("btntextbgclr")
    useEffect(() => {
  
      if (watchbtntextbgclr !== "") {
        setPreview(prev => ({ ...prev,button_enabled : watchcheck,button_link: watchbtnurl, button_text: watchbtntext, btn_text_lang: watchbuttonLang, btn_text_clr: watchbtntextclr, btn_text_bgclr: watchbtntextbgclr}));
      } else {
        setPreview(prev => ({ ...prev,button_enabled : watchcheck,button_link: watchbtnurl, button_text: watchbtntext, btn_text_lang: watchbuttonLang, btn_text_clr: watchbtntextclr, btn_text_bgclr: '' }));
      }
    }, [watchbtntextbgclr]);
    let watchbtntype = watch("btn_type",'0')

    useEffect(() => {
  
      if (watchbtntype !== "") {
        setPreview(prev => ({ ...prev,btn_type:watchbtntype}));
      } else {
        setPreview(prev => ({ ...prev,btn_type:'0' }))
      }
    }, [watchbtntype]);
  
    useEffect(() => {
      if (flag === "edit") {
        setPreview(prev => ({
          ...prev,
          sub_type: editdata.sub_type,
          img_urls: editdata.img_urls,
          logo_urls:editdata.gallery?.image,
          headline:editdata.head_line,
          description:editdata.description,
          brand_name:editdata.gallery?.brand_name,
          caption:editdata.gallery?.caption,
          // position: editdata.position === 0 ? "Top" : "Bottom",
          button_enabled: editdata.button_enabled,
          button_text: editdata.button_text,
          button_link: editdata.button_link,
          btn_text_clr:editdata.btn_text_clr,
          btn_text_bgclr:editdata.btn_text_bgclr,
          background:editdata.gallery?.background,
          btn_type:editdata.gallery?.btn_type
        }));
      }
      setPreview(prev => ({...prev, sub_type:'rectangle_classified'}))
    }, [company]);
  
  
  
    const onSubmit = async (data) => {
      if (flag === "add") {
        handlesubmit(true);
        let obj = {
          company_id: company,
          company_name: companyName,
          creative_name,
          creative_type,
          sub_type: subtype,
          img_url: imgurl,
          clickurl: data.clickurl,
          impurl: { primary: data.impurl, secondary: data.impurl1 },
          btnclick: watchcheck,
          btntext: data.btntext,
          btnurl: data.btnurl,
          btn_text_clr:data.btntextclr,
          btn_text_bgclr:data.btntextbgclr,
          background:data.background,
          headline:data.headline,
          description:data.description,
          btn_type:data.btn_type
  
        };
        // if (advId !== "" && creative_name !== "") {
        if (creative_name !== "") {
          try {
            let res = await api({
              url: `/creatives/classifieds/rectangle`,
              method: "POST",
              responseType: "json",
              data: obj,
            });
            if (res?.code === 200) {
              Toast("success", " Creative Created Successfully  ");
              handleshow(false);
              createdEdited(true);
            } else {
              Toast("error", res.data.message);
            }
          } catch (error) {
            console.error(error);
            if (error.response.status === 401) navigate("/");
          }
        }
      } else if (flag === "edit") {
        let obj = {
          creative_id: editdata.creative_id,
          creative_name: creative_name,
          clickurl: data.clickurl,
          impurl: { primary: data.impurl, secondary: data.impurl1 },
          headline:data.headline,
          description:data.description,
          background:data.background,
          
        };
        imgurl !== "" ? (obj.img_url = imgurl) : (obj.img_url = editdata.img_urls);
        logoUrl !== "" ? (obj.logo_url = logoUrl) : (obj.logo_url = editdata.gallery?.image)
        watchcheck === true ? (obj.btnclick = true) : (obj.btnclick = false);
        watchcheck === true ? (obj.btntext = data.btntext) : (obj.btntext = "");
        watchcheck === true ? (obj.btnurl = data.btnurl) : (obj.btnurl = "");
        watchcheck === true ? (obj.btn_text_clr = data.btntextclr) : (obj.btn_text_clr = "");
        watchcheck === true ? (obj.btn_text_bgclr = data.btntextbgclr) : (obj.btn_text_bgclr = "");
        watchcheck === true ? (obj.btn_type = data.btn_type) : (obj.btn_type = 0);
        try {
          let res = await api({
            url: `/creatives/classifieds/editrectangle`,
            method: "POST",
            responseType: "json",
            data: obj,
          });
          if (res?.code === 200) {
            Toast("success", " Creative Edited Successfully  ");
            handleshow(false);
            createdEdited(true);
          } else {
            Toast("error", res.data.message);
  
          }
        } catch (error) {
          console.error(error);
          if (error.response.status === 401) navigate("/");
        }
      }
    };
    const selectedCategory = watch("category");

    const handleCategoryChange = async(selectedCategory)=>{
      try{
        const response = await api({
          url: `/creatives/classifieds/getImages`,
          method: "POST",
          responseType: "json",
          data: {
            category:selectedCategory
          },
        });
        if(response.code == 200)
        {  
          setimageurls(response?.data)
        }
      console.log("Response",selectedCategory);
      }catch(err)
      {
        console.error("error fetching data",err);
      }
    }
    useEffect(() => {
      if (selectedCategory) {
        setValue("image", "")
        setImgurl("");
        handleCategoryChange(selectedCategory);
      }
    }, [selectedCategory,showImageModal]);
  
    let fetchedurl = watch("imageurl")
    useEffect(()=>{
      if(fetchedurl)
      setImgurl(fetchedurl);
    },[fetchedurl])
  
    return (
      <>
        <div className="row">
          <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
            <div className="row">
              <section className="col-12">
                <div className="mb-3">
                  <label className="form-label">Title Image</label><br />
                  <span>(Image size 60 * 54 Px )</span>
                  <input
                    className="form-control mb-2"
                    type="file"
                    id="formFile"
                    name="files"
                    {...register("image", {
                      required: false,
                      onChange: (e) => imageChange(e),
                    })}
                  />
                  {errors.image && (
                    <p className="text-red-600">Image is mandatory</p>
                  )}
                  {
                    progress > 0 && progress < 100 ? <SlProgressBar value={progress}>{progress}%</SlProgressBar> : imgurl !== "" ? (
                      <span>{`${imgurl}`}</span>
                    ) : (
                      flag === "edit" && <span>{`${editdata.img_urls}`}</span>
                    )}
                </div>
                <div>
                  <h6 className="text-center">OR</h6>
                </div>
                <div className="mb-3">
                  <div className="row align-items-end">
                    <div className="col-md-4">
                      <label className="form-label">Category</label>
                      <select
                        className="form-select"
                        placeholder="Select Category"
                        {...register("category", {
                        })}
                      >
                        <option value="">Select category</option>
                        {classifiedSectionCategories.map((category) => (
                          <option key={category.value} value={category.value}>
                            {category.label}
                          </option>
                        ))}
                      </select>
                      {errors.section && (
                        <p className="text-red-600">{errors.section.message}</p>
                      )}
                    </div>
                    {imageurls.length > 0 && <div className="col-md-4">
                      <label className="form-label">Select Image</label>
                      <select
                        className="form-select"
                        {...register("imageurl", {
                        })}
                      >
                        <option value="">Select Image</option>
                        {imageurls.map((row) => (
                          <option key={row.img_url} value={row.img_url}>
                            {row.image_name}
                          </option>
                        ))}
                      </select>
                    </div>}
                    <div className="col-md-4">
                    <button 
                    type="button"
                    className="btn btn-primary" 
                    onClick={() => {
                      if(selectedCategory)
                      setShowImageModal(true)
                      else
                      Toast("error","Please select Please select a category")
                    }}>
                      Add Image
                    </button>
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                <label className="form-label">Headline</label>&nbsp;&nbsp;&nbsp;<span className={`${watchheadline?.length <= 60 ? 'text-green-400' : 'text-red-500'}`}>{60 - watchheadline?.length} Characthers left</span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Headline"
                      defaultValue={editdata.head_line }
                      name="headline"
                      {...register("headline", {
                        required: 'Headline is required!',
                       
                      })}
                    />
                    {errors.headline && (
                      <p className="text-red-600">{'Title is required!'}</p>
                    )}
                </div>
                <div className="mb-3">
                <label className="form-label">Description</label>&nbsp;&nbsp;&nbsp;&nbsp;<span className={`${watchdescription?.length <= 140 ? 'text-green-400' : 'text-red-500'}`}>{140 - watchdescription?.length} Characthers left</span>
                    <textarea
                    rows={3}
                      type="text"
                      className="form-control"
                      placeholder="Enter Description"
                      defaultValue={editdata.description }
                      name="description"
                      {...register("description", {
                        required: 'Description is required!',
                       
                      })}
                    />
                    {errors.description && (
                      <p className="text-red-600">{'Description is required!'}</p>
                    )}
                </div>
                <div className="row mb-3">
                  <div className="col">
                    <label className="form-label">Click URL / Mobile Number</label>
                    <input
                      type="text"
                      className="form-control"
                      defaultValue={editdata.click_url !== '12' ? editdata.click_url : ''}
                      name="clickurl"
                      {...register("clickurl", {
                        required: false,
                        pattern: {
                          value:
                         /^((https?|ftp):\/\/[^\s\/$.?#].[^\s]*)$|^(www\.[^\s\/$.?#].[^\s]*)$|^([6-9]\d{9})$|^(0[6-9]\d{9})$/,
                          message: "Enter a Valid URL or Mobile Number",
                        },
                      })}
                    />
                    {errors.clickurl && (
                      <p className="text-red-600">{errors.clickurl.message}</p>
                    )}
                  </div>
                  <div className="col">
                    <label className="form-label">Impression URL - Primary</label>
                    <input
                      type="text"
                      className="form-control"
                      defaultValue={
                        editdata.impression_tracking_url
                          ? editdata.impression_tracking_url.primary
                          : null
                      }
                      {...register("impurl", {
                        required: false,
                        pattern: {
                          value:
                            /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                          message: "Enter a Valid URL",
                        },
                      })}
                    />
                    {errors.impurl && (
                      <p className="text-red-600">{errors.impurl.message}</p>
                    )}
                  </div>
                  <div className="col">
                    <label className="form-label">
                      Impression URL - Secondary
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      defaultValue={
                        editdata.impression_tracking_url
                          ? editdata.impression_tracking_url.secondary
                          : null
                      }
                      {...register("impurl1", {
                        required: false,
                        pattern: {
                          value:
                            /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                          message: "Enter a Valid URL",
                        },
                      })}
                    />
                    {errors.impurl1 && (
                      <p className="text-red-600">{errors.impurl1.message}</p>
                    )}
                  </div>
                </div>
                <div className="mb-3">
                <label className="form-label">Background</label>
                    <select
                      className="form-select"
                      defaultValue={editdata.gallery?.background }
                      name="brand_name"
                      {...register("background", {
                        required: 'Background is required!',
                       
                      })}
                    >
                      <option value={1}>Gradient-1</option>
                      <option value={2}>Gradient-2</option>
                      <option value={3}>Gradient-3</option>
                    </select>
                    {errors.background && (
                      <p className="text-red-600">{'Background is required!'}</p>
                    )}
                </div>
                <section>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={watchcheck}
                    {...register("btnclick", { required: false })}
                  />
                  <label className="form-check-label" htmlFor="flexCheckDefault">
                    Enable Button Click
                  </label>
                </div>
                {watchcheck && (
                  <>
                  <div className="row mb-1">
                    <div className="col">
                      <label htmlFor="" className="form-label">
                        Button Text
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        defaultValue={editdata.button_text}
                        {...register("btntext", { required: watchcheck })}
                      />
                      {errors.btntext && (
                        <p className="text-red-600">Button Text is mandatory</p>
                      )}
                    </div>
                    <div className="col">
                      <label htmlFor="" className="form-label">
                        Button Text color
                      </label>
                      <input
                        type="color"
                        defaultValue={editdata.btn_text_clr}
                        {...register("btntextclr", { required: watchcheck })}
                      />
                      {errors.btn_text_clr && (
                        <p className="text-red-600">Button Text color is mandatory</p>
                      )}
                    </div>
  
                    <div className="col">
                      <label htmlFor="" className="form-label">
                        Button Text background color
                      </label>
                      <input
                        type="color"
                        defaultValue={flag === "edit" ? editdata.btn_text_bgclr : "#ffffff"}
                        {...register("btntextbgclr", { required: watchcheck })}
                      />
                      {errors.btn_text_clr && (
                        <p className="text-red-600">Button Text background color  is mandatory</p>
                      )}
                    </div>
  
                    <div className="col">
                      <label htmlFor="" className="form-label">
                        Button Link
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        defaultValue={editdata.button_link}
                        {...register("btnurl", {
                          required: watchcheck,
                          pattern: {
                            value:
                          /^((https?|ftp):\/\/[^\s\/$.?#].[^\s]*)$|^(www\.[^\s\/$.?#].[^\s]*)$|^([6-9]\d{9})$|^(0[6-9]\d{9})$/,
                            message: "Enter a Valid URL",
                          },
                        })}
                      />
                      {errors.btnurl?.type === "pattern" && (
                        <p className="text-red-600">{errors.btnurl.message}</p>
                      )}
                      {errors.btnurl
                        ? errors.btnurl?.type !== "pattern" && (
                            <p className="text-red-600">
                              {"Button URL Mandatory"}
                            </p>
                          )
                        : null}
                    </div>
                   
                   
  
                  </div>
                  <div>
                    <label className="form-label">Icon</label>

                    <div className="d-flex gap-4">
                      {iconOptions.map(({ label, value }) => (
                        <div className="form-check" key={value}>
                          <label className="form-check-label" htmlFor={`btn_type_${value}`}>
                            {label}
                          </label>
                          <input
                            className="form-check-input"
                            type="radio"
                            id={`btn_type_${value}`}
                            value={value}
                            defaultChecked={editdata?.gallery?.btn_type === value}
                            {...register("btn_type", {
                              required: true,
                            })}
                          />
                        </div>
                      ))}
                    </div>

                    {errors.btn_type && (
                      <p className="text-red-600">Please Choose Icon</p>
                    )}
                  </div>
                  </>
                )}
              </section>
                <div className="my-3 text-end">
                  <button type="submit" className="btn btn-primary" disabled={(progress > 0 && progress < 100) ? true : false}>
                    Save Creative
                  </button>
                </div>
              </section>
            </div>
          </form>
        </div>
        <SlDrawer
              open={showImageModal}
              onSlAfterHide={(e) => {e.preventDefault(); e.stopPropagation();setShowImageModal(false);resetDrawer()}}
              onSlRequestClose={(e) => {e.preventDefault(); e.stopPropagation();
                setShowImageModal(false);resetDrawer()}}
              noHeader
              style={{ '--size': '400px', background: 'white' }}
            >
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <button
                  className="w-12 h-12"
                  type="button"
                  onClick={e => {
                    e.preventDefault();
                    setShowImageModal(false);
                    e.stopPropagation();
                  }}
                  aria-label="Close"
                >
                  &times;
                </button>
              </div>
              <form
                className="pt-8"
                onSubmit={async (e) => {
                  e.preventDefault();
                    try{
                    let res2 = await api({
                      url: `/creatives/classifieds/addImages`,
                      method: "POST",
                      responseType: "json",
                      data: {
                        category:selectedCategory,
                        imageName:imageName,
                        url:newimageurl,
                      },
                    })
                  }catch(err)
                  {
                    console.log(err.message || "");
                  }
                  setShowImageModal(false);
                }}
              >
                <div className="mb-6">
                  <label className="block text-sm font-medium mb-1">Image Name</label>
                  <input
                    type="text"
                    className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring focus:border-blue-400"
                    value={imageName}
                    onChange={e => setImageName(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-6">
                  <label className="block text-sm font-medium mb-1">Upload Image</label>
                  <input
                    ref={fileInputRef}
                    type="file"
                    className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring focus:border-blue-400"
                    accept="image/*"
                    onChange={e => newimageChange(e)}
                    required
                  />
                </div>
                <button
                  className="w-full px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  Upload
                </button>
              </form>
            </SlDrawer>
      </>
    );
  }
  
  export default RectangleClassified;